import { render, staticRenderFns } from "./BoardController.vue?vue&type=template&id=159c1c51&scoped=true&lang=pug&"
import script from "./BoardController.vue?vue&type=script&lang=js&"
export * from "./BoardController.vue?vue&type=script&lang=js&"
import style0 from "./BoardController.vue?vue&type=style&index=0&id=159c1c51&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c1c51",
  null
  
)

export default component.exports